import BasicContentComponent from "./Career/BasicContentComponent"
import CollegesCareer from "./Career/CollegesCareer"
import DriversCareer from "./Career/DriversCareer"
import HeadquarterCareer from "./Career/HeadquarterCareer"
import SingleJob from "./Career/SingleJob"
import CargoWagons from "./CargoWagons/CargoWagons"
import ContactUs from "./ContactUs"
import Terms from "./Content/Terms"
import ContentPage from "./ContentPage/ContentPage"
import CorporateGovernance from "./CorporateGovernance/CorporateGovernance"
import EggedTransportation from "./EggedTransportation/EggedTransportation"
import Eligibility from "./Eligibility/Eligibility"
import FAQ from "./FAQ/FAQ"
import FinePayment from "./Finepayment/FinePayment"
import GeneralPage from "./GeneralPage/GeneralPage"
import HistoryPage from "./History/HistoryPage"
import Homepage from "./Homepage/Homepage"
import InformationPassengers from "./InformationPassengers/InformationPassengers"
import JourneyPlanner from "./JourneyPlanner/JourneyPlanner"
import MaintenancePage from "./MaintenancePage/MaintenancePage"
import NotFound from "./NotFound/NotFound"
import KavStations from "./PaymentApps/KavStations"
import PaymentApps from "./PaymentApps/PaymentApps"
import PeopleOfEgged from "./PeopleOfEgged/PeopleOfEgged"
import SitemapComp from "./Sitemap/Sitemap"
import TrafficIndividualSkeleton from "./TrafficUpdates/IndividualSkeleton"
import TrafficIndividual from "./TrafficUpdates/TrafficIndividual"
import TrafficLobby from "./TrafficUpdates/TrafficLobby"
export {
  BasicContentComponent as BasicContentComponent,
  CargoWagons as CargoWagons,
  CollegesCareer as CollegesCareer,
  ContactUs as ContactUs,
  ContentPage as ContentPage,
  CorporateGovernance as CorporateGovernance,
  DriversCareer as DriversCareer,
  EggedTransportation as EggedTransportation,
  Eligibility as Eligibility,
  FAQ as FAQ,
  FinePayment as FinePayment,
  GeneralPage as GeneralPage,
  HeadquarterCareer as HeadquarterCareer,
  HistoryPage as HistoryPage,
  Homepage as Homepage,
  InformationPassengers as InformationPassengers,
  JourneyPlanner as JourneyPlanner,
  KavStations as KavStations,
  MaintenancePage as MaintenancePage,
  NotFound as NotFound,
  PaymentApps as PaymentApps,
  PeopleOfEgged as PeopleOfEgged,
  SingleJob as SingleJob,
  SitemapComp as SitemapComp,
  Terms as Terms,
  TrafficIndividual as TrafficIndividual,
  TrafficIndividualSkeleton as TrafficIndividualSkeleton,
  TrafficLobby as TrafficLobby,
}
